import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6 0H8.99983H9.00017H9.5C9.77614 0 10 0.223858 10 0.5V0.999307V1.00069V4C10 4.20223 9.87818 4.38455 9.69134 4.46194C9.5045 4.53933 9.28945 4.49655 9.14645 4.35355L8.10355 3.31066L2.20711 9.20711C1.81658 9.59763 1.18342 9.59763 0.792893 9.20711C0.402369 8.81658 0.402369 8.18342 0.792893 7.79289L6.68934 1.89645L5.64645 0.853553C5.50345 0.710554 5.46067 0.495495 5.53806 0.308658C5.61545 0.121821 5.79777 0 6 0ZM13.2071 6.20711C13.5976 5.81658 13.5976 5.18342 13.2071 4.79289C12.8166 4.40237 12.1834 4.40237 11.7929 4.79289L5.89645 10.6893L4.85355 9.64645C4.71055 9.50345 4.4955 9.46067 4.30866 9.53806C4.12182 9.61545 4 9.79777 4 10V13V13.5C4 13.7761 4.22386 14 4.5 14H4.99931H5.00069H8C8.20223 14 8.38455 13.8782 8.46194 13.6913C8.53933 13.5045 8.49655 13.2894 8.35355 13.1464L7.31066 12.1036L13.2071 6.20711Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }